<script>
import Navbar from '@components/Navbar';
import BlockingContainer from '@components/BlockingContainer';

export default {
  components: {
    Navbar,
    BlockingContainer,
  },
  props: {
    fluid: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    // Ensure background is reset to default when using main layout
    document.body.style.backgroundColor = '';
  },
};
</script>

<template>
  <div>
    <Navbar />
    <b-container :fluid="fluid" class="pt-4 mb-4">
      <b-row>
        <b-col>
          <BlockingContainer v-if="$wait.is('global loading')" />
          <slot />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<style lang="scss" module>
@import '@design';
</style>
